/** Yahoo / UI column labels for Buy Recommendation (shared by table + CSV). */

export const STOCK_BUY_REC_TABLE_COLUMNS = [
  { id: "Symbol", label: "Symbol" },
  { id: "Company Name", label: "Company Name" },
  { id: "Last Price", label: "Last Price" },
  { id: "Change (%)", label: "Change (%)" },
  { id: "52-Wk High Chg %", label: "52-Wk High Chg %" },
  { id: "52-Wk Low Chg %", label: "52-Wk Low Chg %" },
  { id: "52-DMA Chg %", label: "52-DMA Chg %" },
  { id: "Market Cap", label: "Market Cap" },
  { id: "Earnings Date", label: "Earnings Date" },
  { id: "P/E Ratio (TTM)", label: "P/E Ratio (TTM)" },
  { id: "Forward P/E", label: "Forward P/E" },
  { id: "Price/Sales", label: "Price/Sales" },
  { id: "Short Ratio", label: "Short Ratio" },
  { id: "Equity", label: "Equity" },
];

/** @deprecated Use STOCK_BUY_REC_TABLE_COLUMNS ids — kept for callers expecting label list. */
export const STOCK_BUY_REC_DISPLAY_COLUMNS = STOCK_BUY_REC_TABLE_COLUMNS.map((c) => c.id);

export const STOCK_BUY_REC_TABLE_DEFAULT_VISIBLE = [
  "Symbol",
  "Company Name",
  "Change (%)",
  "52-Wk High Chg %",
  "52-Wk Low Chg %",
  "52-DMA Chg %",
  "Earnings Date",
  "Equity",
];

export const STOCK_BUY_REC_TABLE_KEY = "stock.yahoo.table";

export const STOCK_BUY_REC_PCT_COLUMNS = new Set([
  "Change (%)",
  "52-Wk High Chg %",
  "52-Wk Low Chg %",
  "52-DMA Chg %",
]);

/**
 * @param {string[]} visibleColumnIds
 */
export function resolveBuyRecVisibleColumns(visibleColumnIds) {
  const allowed = new Set(STOCK_BUY_REC_TABLE_COLUMNS.map((c) => c.id));
  const ids = Array.isArray(visibleColumnIds) ? visibleColumnIds.filter((id) => allowed.has(id)) : [];
  if (ids.length > 0) return ids;
  return [...STOCK_BUY_REC_TABLE_DEFAULT_VISIBLE];
}

/**
 * @param {string[]} columnIds
 */
export function stockBuyRecColumnsFromIds(columnIds) {
  const byId = new Map(STOCK_BUY_REC_TABLE_COLUMNS.map((c) => [c.id, c]));
  return (columnIds || []).map((id) => byId.get(id)).filter(Boolean);
}
